import type {
  FieldComponents,
  UploadedFile,
} from '@/shared/components/form-fields/types';
import { withForm } from '../../hooks/use-proposal-decision-form.hook';
import {
  ACCEPT_FILE_TYPES_STRING,
  ATTACHMENTS_HELPER_TEXT,
  decisionFormOpts,
  validateAttachments,
} from './decision-form-options';

export const DecisionAttachmentsField = withForm({
  ...decisionFormOpts,
  props: {},
  render: ({ form }) => (
    <form.AppField
      name='attachments'
      validators={{
        onChange: ({ value }: { value: UploadedFile[] | undefined }) =>
          validateAttachments(value),
        onSubmit: ({ value }: { value: UploadedFile[] | undefined }) =>
          validateAttachments(value),
      }}
      children={(field: FieldComponents) => (
        <field.UploadField
          label='Anexos'
          accept={ACCEPT_FILE_TYPES_STRING}
          helperText={ATTACHMENTS_HELPER_TEXT}
          multiple
        />
      )}
    />
  ),
});
